import { Pipe, PipeTransform } from '@angular/core';
import { IFacetedPageDTO } from '../dto/faceted-page.dto';
import { PageUtil, Page } from '../util/page.util';

/**
 * @description
 *
 * The `convertFacetedPageToPage` pipe converts a IFacetedPageDTO<T> into a Page<T>
 *
 * @usageNotes
 *
 * ```
 * {{ usersFacetedPage | convertFacetedPageToPage }}
 * <!--will convert usersFacetedPage of type IFacetedPageDTO<IUserModel> or null into Page<IUserModel>-->
 * ```
 *
 */
@Pipe({
    name: 'convertFacetedPageToPage',
    standalone: true,
})
export class ConvertFacetedPageToPagePipe implements PipeTransform {
    transform<T>(facetedPage: IFacetedPageDTO<T> | null): Page<T> | null {
        return facetedPage ? PageUtil.convertToPage(facetedPage.page) : null;
    }
}
